import { IS_PREVIEW } from "../config";
import liveRepository from "./liveRepository";
import previewRepository from "./previewRepository";

const repository = IS_PREVIEW ? previewRepository : liveRepository;

export default repository;
